import React from "react";
import { useTranslation } from "react-i18next";

import MessageBox from "../../../../components/MessageBox";
import ModalContainer from "../../../../components/ModalContainer";
import Button from "../../../../components/Button";
import InputWithUploadButton from "../../../../components/InputWithUploadButton";


const UploadImg = (props) => {
  const { t } = useTranslation();
  const {
    isOpenUploadImgModal,
    setOpenUploadImgModal,
    uploadFileMessages,
    setUploadFileMessages,
    defaulUploadFileMessages,
    uploadFile,
    onFileSelect,
    onUploadFile
  } = props;

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={isOpenUploadImgModal}
      closeModal={() => setOpenUploadImgModal(false)}
    >
      <div className='header'>
        <div className='title'>{t('1f98842c35')}</div>
      </div>
      <div className='body'>
        <MessageBox
          show={uploadFileMessages.show}
          label={uploadFileMessages.label}
          variant='danger'
          onClose={() => setUploadFileMessages({ ...defaulUploadFileMessages, show: false })
          } />
        <div className='mb-1'>{t('42c4480d88')}</div>
        <InputWithUploadButton
          buttonLabel='1b9abf135c'
          value={uploadFile ? uploadFile.name : ''}
          onClick={e => {onFileSelect(e.target.value = null)}}
          onChange={e => {onFileSelect(e.target.files[0])}}
        />
      </div>
      <div className='footer'>
        <Button
          label={t('ea4788705e')}
          className='btn-cancel'
          onClick={() => setOpenUploadImgModal(false)}
        />
        <Button
          label={t('91412465ea')}
          className='btn-submit'
          onClick={() => {onUploadFile(uploadFile)}}
        />
      </div>
    </ModalContainer>
  )
}

export default React.memo(UploadImg);